import { createContext, useState } from 'react';
import {
    Control, SubmitHandler, useForm, UseFormClearErrors, UseFormTrigger, UseFormWatch
} from 'react-hook-form';

import Fetching from '../../../components/misc/Fetching';
import StepsComponent from '../../../components/misc/StepsComponent';
import { cleanObj } from '../../../utils/helpers';
import OnlinePersonalData from './OnlinePersonalData';
import PhonesData from './PhonesData';

interface AddClientInterface {
  control: Control
  watch: UseFormWatch<Record<string, string | boolean | number | string[]>>
  trigger: UseFormTrigger<Record<string, string | boolean | number | string[]>>
  nextStep: Function
  beforeStep: Function
  getValues: Function
  clearErrors: UseFormClearErrors<Record<string, any>>
}

interface WizzardInterface {
  addClient: Function
  isFetching: boolean
  closeModal: Function
}

export const AddClientCtx = createContext<Partial<AddClientInterface>>({})

const AddClientWizzard = ({
  addClient,
  isFetching,
  closeModal,
}: WizzardInterface) => {
  const { control, handleSubmit, watch, trigger, getValues, clearErrors } =
    useForm()

  const [currentStep, setCurrentStep] = useState(0)
  const nextStep = () => setCurrentStep(currentStep + 1)
  const beforeStep = () => setCurrentStep(currentStep - 1)

  const onSubmit: SubmitHandler<Record<string, string | number | boolean>> = (
    data
  ) => {
    addClient(cleanObj(data), closeModal)
  }

  if (isFetching)
    return (
      <div className="h-96">
        <Fetching />
      </div>
    )
  return (
    <>
      <StepsComponent
        current={currentStep}
        titles={['Datos personales', 'Teléfonos']}
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <AddClientCtx.Provider
          value={{
            control,
            watch,
            trigger,
            nextStep,
            beforeStep,
            getValues,
            clearErrors,
          }}
        >
          {currentStep === 0 && <OnlinePersonalData />}
          {currentStep === 1 && <PhonesData />}
        </AddClientCtx.Provider>
      </form>
    </>
  )
}

export default AddClientWizzard
